export default __webpack_public_path__ + "static/media/picture1.1b138897.png";